import React from 'react';
import { ArrowRight, Download, Phone } from 'lucide-react';
import ProductGallery from '../ProductGallery';
import { PRODUCT_GALLERIES } from '../../data/productGalleries';
import { ACCENTS, Icon } from './theme';

export const ProductHero = ({ product }) => {
  const { hero, name, slug, testid, brochureUrl, accent } = product;
  const t = ACCENTS[accent];
  return (
    <section className={`bg-gradient-to-br ${hero.gradient} text-white py-20 px-6 lg:px-12 overflow-hidden`}>
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="min-w-0">
            <p className="font-heading text-sm font-bold tracking-[0.3em] text-white/50 uppercase mb-3">Harpalyk</p>
            <span className={`inline-block ${t.heroBadge} px-4 py-2 rounded-full text-sm font-medium mb-6`}>
              {hero.badge}
            </span>
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight mb-6">{name}</h1>
            <p className={`text-2xl ${t.heroTagline} font-semibold mb-4`}>{hero.tagline}</p>
            <p className={`text-xl text-gray-300 ${hero.price ? 'mb-6' : 'mb-8'} leading-relaxed`}>{hero.description}</p>

            {hero.price && (
              <div className="flex items-baseline gap-3 mb-8">
                <span className="text-4xl font-bold text-white" data-testid={`${testid}-price`}>{hero.price.amount}</span>
                <span className={`${t.heroPriceNote} text-sm`}>{hero.price.note}</span>
              </div>
            )}

            <div className="grid grid-cols-2 gap-4 mb-8 min-w-0">
              {hero.highlights.map((item) => (
                <div key={item.label} className="flex items-center gap-2 bg-white/10 backdrop-blur px-4 py-3 rounded-lg min-w-0">
                  <Icon name={item.icon} className={`w-5 h-5 flex-shrink-0 ${t.heroIcon}`} />
                  <span className="text-sm font-medium break-words min-w-0">{item.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-4">
              <a href="#contact" data-testid={`${testid}-quote-btn`} className={`${t.ctaPrimary} text-white px-8 py-4 rounded-lg font-semibold flex items-center gap-2 transition-all`}>
                Request Quote <ArrowRight className="w-5 h-5" />
              </a>
              <a href={brochureUrl} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-brochure-btn`} className="border-2 border-white/30 hover:border-white text-white px-8 py-4 rounded-lg font-semibold flex items-center gap-2 transition-all">
                <Download className="w-5 h-5" /> Download Brochure
              </a>
              <a href="tel:+917011370322" className={`border-2 ${t.ctaOutline} px-8 py-4 rounded-lg font-semibold flex items-center gap-2 transition-all`}>
                <Phone className="w-5 h-5" /> Contact Sales
              </a>
            </div>
          </div>

          <ProductGallery images={PRODUCT_GALLERIES[slug]} accent={hero.galleryAccent} badge={hero.galleryBadge} testid={`${testid}-gallery`} />
        </div>
      </div>
    </section>
  );
};
